export const formatPrecio = (precio, moneda = "MXN", mostrar = true) => {
  if (!mostrar) return "Consultar precio";
  if (!precio) return "Consultar precio";
  return new Intl.NumberFormat("es-MX", {
    style: "currency", currency: moneda, maximumFractionDigits: 0,
  }).format(precio);
};

export const formatFecha = (fecha) => {
  if (!fecha) return "—";
  return new Intl.DateTimeFormat("es-MX", {
    day: "2-digit", month: "short", year: "numeric",
  }).format(new Date(fecha));
};

export const TIPOS_PROPIEDAD = [
  { value: "CASA", label: "Casa", emoji: "🏠" },
  { value: "DEPARTAMENTO", label: "Departamento", emoji: "🏢" },
  { value: "TERRENO", label: "Terreno", emoji: "🌱" },
  { value: "LOCAL_COMERCIAL", label: "Local Comercial", emoji: "🏪" },
  { value: "BODEGA", label: "Bodega", emoji: "🏭" },
  { value: "OFICINA", label: "Oficina", emoji: "💼" },
  { value: "EDIFICIO", label: "Edificio", emoji: "🏗️" },
  { value: "RANCHO", label: "Rancho", emoji: "🌿" },
  { value: "QUINTA", label: "Quinta", emoji: "🏡" },
  { value: "OTRO", label: "Otro", emoji: "⬜" },
];

export const CIUDADES = [
  "Córdoba", "Fortín", "Orizaba", "Boca del Río", "Veracruz", "Xalapa", "Otra",
];

export const AMENIDADES = [
  { value: "alberca", label: "Alberca", emoji: "🏊" },
  { value: "jardín", label: "Jardín", emoji: "🌿" },
  { value: "roof_garden", label: "Roof garden", emoji: "🏔️" },
  { value: "terraza", label: "Terraza", emoji: "🌅" },
  { value: "asador", label: "Asador / BBQ", emoji: "🔥" },
  { value: "cocina_integral", label: "Cocina integral", emoji: "🍳" },
  { value: "closets", label: "Closets", emoji: "👔" },
  { value: "cuarto_servicio", label: "Cuarto de servicio", emoji: "🛎️" },
  { value: "bodega_extra", label: "Bodega extra", emoji: "📦" },
  { value: "cuarto_lavado", label: "Cuarto de lavado", emoji: "🧺" },
  { value: "elevador", label: "Elevador", emoji: "🛗" },
  { value: "vigilancia_24h", label: "Vigilancia 24h", emoji: "👮" },
  { value: "caseta_seguridad", label: "Caseta de seguridad", emoji: "🏠" },
  { value: "camaras_cctv", label: "Cámaras CCTV", emoji: "📷" },
  { value: "acceso_controlado", label: "Acceso controlado", emoji: "🚧" },
  { value: "gym", label: "Gimnasio", emoji: "💪" },
  { value: "salon_eventos", label: "Salón de eventos", emoji: "🎉" },
  { value: "area_juegos", label: "Área de juegos", emoji: "🎢" },
  { value: "calentador_solar", label: "Calentador solar", emoji: "☀️" },
  { value: "paneles_solares", label: "Paneles solares", emoji: "🔋" },
];

export const getLabelTipo = (value) =>
  TIPOS_PROPIEDAD.find((t) => t.value === value)?.label || value;

export const getEmojiTipo = (value) =>
  TIPOS_PROPIEDAD.find((t) => t.value === value)?.emoji || "🏠";

export const STATUS_COLORES = {
  ACTIVA: { bg: "#DCFCE7", color: "#166534", label: "Activa" },
  INACTIVA: { bg: "#F3F4F6", color: "#6B7280", label: "Inactiva" },
  VENDIDA: { bg: "#FEE2E2", color: "#991B1B", label: "Vendida" },
  RENTADA: { bg: "#FEF3C7", color: "#92400E", label: "Rentada" },
  RESERVADA: { bg: "#EDE9FE", color: "#5B21B6", label: "Reservada" },
};

export const CONTACT_STATUS = {
  NUEVO: { bg: "#DBEAFE", color: "#1E40AF", label: "Nuevo" },
  EN_SEGUIMIENTO: { bg: "#FEF3C7", color: "#92400E", label: "En seguimiento" },
  ATENDIDO: { bg: "#DCFCE7", color: "#166534", label: "Atendido" },
  DESCARTADO: { bg: "#F3F4F6", color: "#6B7280", label: "Descartado" },
};
